import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Comics from "@/pages/Comics";
import Shop from "@/pages/Shop";
import Cart from "@/pages/Cart";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Videos from "@/pages/Videos";
import Chat from "@/pages/Chat";
import About from "@/pages/About";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import ComicReader from "@/pages/ComicReader";
import TheThrone from "@/pages/TheThrone";
import { CartProvider } from "@/lib/cart";
import { AuthProvider } from "@/lib/auth";

export default function App() {
  return (
    <div className="App" data-testid="app-root">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/comics" element={<Comics />} />
                <Route path="/comics/:id/read" element={<ComicReader />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogDetail />} />
                <Route path="/videos" element={<Videos />} />
                <Route path="/chat" element={<Chat />} />
                <Route path="/about" element={<About />} />
                <Route path="/login" element={<Login />} />
                <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
                <Route path="/the-throne" element={<TheThrone />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}
